// extracted by extract-css-chunks-webpack-plugin
module.exports = {"criteria":"StrongPasswordCriteria-81daff2a098f83f4","criterion":"StrongPasswordCriteria-f591a50444e20fd7"};